export function formatCompanyInfo({ avatar, operational_countries: countries, ...rest }) {
  if (avatar && avatar.file) {
    return {
      ...rest,
      avatar: avatar.file,
      operational_countries: countries.split(','),
    };
  }
  return {
    ...rest,
    operational_countries: countries.split(','),
  };
}

export function formatProfileInfo({ avatar, ...rest }) {
  if (avatar && avatar.file) {
    return {
      ...rest,
      avatar: avatar.file,
    };
  }
  return rest;
}

export function formatProfileResponse(data) {
  const { avatar, company, ...rest } = data;
  return {
    ...rest,
    avatar: {
      url: avatar,
      file: null,
    },
    company: company && {
      ...company,
      avatar: { url: company.avatar, file: null },
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/formFormatter.js